export const supportMigrations = [
  {
    id: '041_support_requests_and_onboarding',
    sql: `
      ALTER TABLE users ADD COLUMN IF NOT EXISTS onboarding_seen_at TIMESTAMPTZ;

      CREATE TABLE support_requests (
        id UUID PRIMARY KEY,
        user_id UUID NOT NULL REFERENCES users(id) ON DELETE CASCADE,
        topic TEXT NOT NULL CHECK (topic IN ('decision','technical','privacy','other')),
        message TEXT NOT NULL,
        status TEXT NOT NULL DEFAULT 'requested'
          CHECK (status IN ('requested','scheduled','accepted','reschedule_requested','completed','cancelled')),
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW()
      );
      CREATE INDEX support_requests_queue_idx ON support_requests (status, updated_at DESC);
      CREATE UNIQUE INDEX support_requests_one_open_idx ON support_requests (user_id)
        WHERE status IN ('requested','scheduled','accepted','reschedule_requested');

      CREATE TABLE support_appointments (
        id UUID PRIMARY KEY,
        support_request_id UUID NOT NULL REFERENCES support_requests(id) ON DELETE CASCADE,
        proposed_by UUID REFERENCES users(id) ON DELETE SET NULL,
        starts_at TIMESTAMPTZ NOT NULL,
        status TEXT NOT NULL DEFAULT 'proposed'
          CHECK (status IN ('proposed','accepted','reschedule_requested','superseded','completed')),
        user_note TEXT NOT NULL DEFAULT '',
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW()
      );
      CREATE INDEX support_appointments_request_idx
        ON support_appointments (support_request_id, created_at DESC);

      ALTER TABLE user_notifications ADD COLUMN support_request_id UUID
        REFERENCES support_requests(id) ON DELETE CASCADE;
      ALTER TABLE user_notifications DROP CONSTRAINT user_notifications_type_check;
      ALTER TABLE user_notifications ADD CONSTRAINT user_notifications_type_check CHECK (type IN (
        'meeting_proposed','meeting_confirmed','meeting_cancelled',
        'schedule_confirmed','call_ready','support_appointment','support_updated'
      ));
    `,
  },
] as const;
